module.exports = __webpack_public_path__ + "static/media/payroll_1.d1b40450.png";